"use strict";

import angular from "angular";

angular.module("nucont.adminUsers", ["nucont.shared"]);
require("./admin-users.routes");
